import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#e0c878',
      light: '#f0dfa0',
      dark: '#b09850',
    },
    secondary: {
      main: '#7a5fff',
      light: '#9d7dff',
      dark: '#5a3bcc',
    },
    background: {
      default: '#1a1a2e',
      paper: '#2c2c54',
    },
    warning: {
      main: '#ff9800',
    },
    success: {
      main: '#4caf50',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Roboto", serif', fontWeight: 700 },
    h2: { fontFamily: '"Roboto", serif', fontWeight: 600 },
    h3: { fontFamily: '"Roboto", serif', fontWeight: 600 },
    h4: { fontFamily: '"Roboto", serif', fontWeight: 600 },
    h5: { fontFamily: '"Roboto", serif', fontWeight: 600 },
    h6: { fontFamily: '"Roboto", serif', fontWeight: 600 },
    body1: { lineHeight: 1.6 },
    body2: { lineHeight: 1.6 },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          // Improve keyboard accessibility
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: '#e0c878',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // Improve keyboard focus for interactive cards
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: '#e0c878',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: '#e0c878',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid',
            outlineColor: '#e0c878',
            outlineOffset: '2px',
          },
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});
